import React from 'react';
import "../../../Lots/categoryModal.scss";

class TextAreaWithLinks extends React.Component {
    state = {
        editMode: false,
        generalDescription: this.props.initialValue || '',
        displayDescription: this.props.initialValue || ''
    };

    componentDidUpdate(prevProps) {
        if (prevProps.initialValue !== this.props.initialValue) {
            this.setState({
                generalDescription: this.props.initialValue || '',
                displayDescription: this.props.initialValue || ''
            });
        }
    }

    urlify = (text) => {
        if (!text) return null;
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.split('\n').map((paragraph, i) => {
            const parts = paragraph.split(urlRegex);
            return (
                <p
                    key={i}
                    style={{
                        fontSize: "14px",
                    }}
                >
                    {parts.map((part, j) =>
                        urlRegex.test(part) ? (
                            <a
                                key={j}
                                href={part}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: 'inherit', textDecoration: "underline", color: "#4267b2" }}
                            >
                                {part}
                            </a>
                        ) : (
                            part
                        )
                    )}
                </p>
            );
        });
    };

    handleTextChange = (e) => {
        const newValue = e.target.value;
        this.setState({ generalDescription: newValue });
        if (this.props.onChange) {
            this.props.onChange(newValue);
        }
    };

    toggleEditMode = () => {
        this.setState(prevState => {
            if (prevState.editMode) {
                const newValue = prevState.generalDescription;
                return {
                    editMode: false,
                    displayDescription: newValue
                };
            } else {
                return { editMode: true };
            }
        });
    };

    render() {
        const { editMode, generalDescription, displayDescription } = this.state;
        const {
            rows = 5,
            placeholder = "General description",
            maxLength = 250,
            className = "",
            style = {}
        } = this.props;

        return (
            <div>
                <div className={`textarea-container ${className}`} style={style}>
                    <div className={`textarea-container ${className}`}
                        style={{
                            minHeight: `calc(${rows} * 1.5em)`,
                            whiteSpace: 'pre-wrap',
                            cursor: 'text',
                            ...style
                        }}
                    >
                        {this.urlify(displayDescription)}
                    </div>
                </div>
            </div>
        );
    }
}

export default TextAreaWithLinks;


// WEBPACK FOOTER //
// ./src/Projects/Components/Inventory/TextAreaWithLinks.js